export default "__VITE_ASSET__CbRuh1KI__"